import React from "react";
import CV_Bhuwan from '../../assets/Bhuwan_Pandey.pdf'

const CTA = () => {
    return (
        <div className="cta">
            <a href={CV_Bhuwan} download className="btn">Download CV</a>
            <a href="#contact" className="btn btn-primary">Let's Talk</a>
        </div>
    );
}

export default CTA;